module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": '充值记录'
    }
  }, [_c('div', {
    staticClass: "tab-title"
  }, [_c('div', {
    staticClass: "tab-btn",
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.changeTab(0)
      }
    }
  }, [_vm._v("奖金充值记录")]), _vm._v(" "), _c('div', {
    staticClass: "tab-btn",
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("预算充值记录")]), _vm._v(" "), _c('div', {
    staticClass: "tab-btn",
    class: {
      active: _vm.activeIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.changeTab(2)
      }
    }
  }, [_vm._v("职级充值记录")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('bonusNote', {
    staticClass: "tab-main",
    attrs: {
      "activeIndex": _vm.activeIndex,
      "index": 0
    }
  }), _vm._v(" "), _c('budgetNote', {
    staticClass: "tab-main",
    attrs: {
      "activeIndex": _vm.activeIndex,
      "index": 1
    }
  }), _vm._v(" "), _c('rankNote', {
    staticClass: "tab-main",
    attrs: {
      "activeIndex": _vm.activeIndex,
      "index": 2
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-31713c1b!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/finance/page-note.vue
// module id = 720
// module chunks = 1